import { render, staticRenderFns } from "./telegramLoginButton.vue?vue&type=template&id=5474b62e&scoped=true&"
import script from "./telegramLoginButton.vue?vue&type=script&lang=js&"
export * from "./telegramLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./telegramLoginButton.vue?vue&type=style&index=0&id=5474b62e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474b62e",
  null
  
)

export default component.exports